import { z } from 'zod';

import { mfaStateSchema } from './auth.js';
import { PERMISSIONS, roleSchema } from './roles.js';
import { impersonationInfoSchema } from './impersonation.js';

export const TENANT_STATUSES = ['onboarding', 'active', 'paused', 'archived'] as const;
export const tenantStatusSchema = z.enum(TENANT_STATUSES);
export type TenantStatus = z.infer<typeof tenantStatusSchema>;

export const permissionSchema = z.enum(PERMISSIONS);

export const accessibleTenantSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  status: tenantStatusSchema,
  /** Rol efectivo (el más alto entre membresías de agencia, cliente y empresa). `null` = superadmin sin membresía. */
  role: roleSchema.nullable(),
  permissions: z.array(permissionSchema),
  /** Web de la empresa (dominio) y logo a mostrar (subido o favicon de la web); null = monograma. */
  website: z.string().nullable().optional(),
  logoUrl: z.string().nullable().optional(),
});
export type AccessibleTenant = z.infer<typeof accessibleTenantSchema>;

export const accessibleClientSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  tenants: z.array(accessibleTenantSchema),
});
export type AccessibleClient = z.infer<typeof accessibleClientSchema>;

export const meResponseSchema = z.object({
  user: z.object({
    id: z.uuid(),
    email: z.string(),
    name: z.string(),
    isSuperadmin: z.boolean(),
    totpEnabled: z.boolean(),
    /** Foto de perfil (mismo origen); null = iniciales. */
    avatarUrl: z.string().nullable().optional(),
  }),
  mfa: mfaStateSchema,
  /** Unión de permisos sobre todas las empresas accesibles: sirve para mostrar u ocultar menús. */
  permissions: z.array(permissionSchema),
  clients: z.array(accessibleClientSchema),
  /** Superadmin "viendo como" otra persona (sólo lectura, 30 min). Ausente/null = sesión propia. */
  impersonation: impersonationInfoSchema.nullable().optional(),
});
export type MeResponse = z.infer<typeof meResponseSchema>;
